import instance from '../utils/axios';

class AttachmentService {

    async getAttachmentsByIds(attachmentIds) {
        return await instance.post("/wf/document/getAttachmentsByIds", {attachmentIds: attachmentIds});
    }
	async share(id) {
        return await instance.post('/crm/link/file/share', {
            attachmentId: id
        });
    }
}

export default new AttachmentService();